import styled from '@emotion/styled';
import { CSSProperties, ReactNode } from 'react';

type P = {
  show: boolean;
  handleClick: () => void;
  children: ReactNode;
  style?: CSSProperties;
};

const FloatingButton = ({ show, handleClick, children, style }: P) => {
  return (
    <StyledButton showButton={show} onClick={handleClick} style={style}>
      {children}
    </StyledButton>
  );
};
export default FloatingButton;

const StyledButton = styled.button<{ showButton: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.12), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(10px);
  visibility: ${({ showButton }) => (showButton ? 'visible' : 'hidden')};
`;
